﻿// note:  I'm exporting everything that inherits from party in this one file. 
// in some earlier code, I ran into a few cases where typescript indicated type incompatibility based upon how I 
// imported an inherted member.  To avoid any problems while we are in "rapid build mode", I'm putting 
// all of the dependencies in one file.  We can refactor at a future date.

export interface IParty {
    id: string;
    partyTypeCId: string;
}

export interface IPolicyholder {
    id:string;
    name:string
    clientSystemReference: string;
    billingAccountNumber: string;
    autopay: boolean;
}

export interface IPolicyholderUser {
    policyholderId: string;
    userId: string;
    relationshipTypeCid: string;
}

export class Policyholder implements IPolicyholder {
    public clientSystemReference: string;
    public billingAccountNumber: string;
    public autopay: boolean;
    public policyholderUsers: IPolicyholderUser[] = [];
    public name: string;
    public id: string;
}

export class PolicyholderUser implements IPolicyholderUser {
    public policyholderId: string;
    public userId: string;
    public relationshipTypeCid: string;
}

export class PolicyholderUserRelationshipType {
    public static primaryContact: string = '133';
    public static billingContact: string = '134';
}
